export enum ShareReportWizardStep {
  LinkNameStep,
  RestrictionsStep,
  RecipientsStep,
  ReviewStep,
  ShareReportStep,
}

export const WIZARD_STEPS_LABELS: Record<ShareReportWizardStep, string> = {
  [ShareReportWizardStep.LinkNameStep]: "Link name",
  [ShareReportWizardStep.RestrictionsStep]: "Restrictions",
  [ShareReportWizardStep.RecipientsStep]: "Recipients",
  [ShareReportWizardStep.ReviewStep]: "Review",
  [ShareReportWizardStep.ShareReportStep]: "Share report",
};
